import { mutationTypes } from '@/core/constants'

export default {
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.HISTORICO.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.HISTORICO.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.HISTORICO.SET_DATASOURCE](state, data) {
		if (data) state.datasource = data
	},
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.HISTORICO.SET_TOTAL_ELEMENTS](state, totalElements) {
		if (totalElements) state.totalElements = totalElements
		else state.totalElements = 0
	},
	[mutationTypes.ITEM_ATA.ALTERAR_CLASSIFICACAO.HISTORICO.SET_TOTAL_PAGES](state, totalPages) {
		if (totalPages) state.totalPages = totalPages
		else state.totalPages = 0
	},
}
